import { NavLink, useParams } from 'react-router'

const I = ({ d }) => (
  <svg width="15" height="15" viewBox="0 0 16 16" fill="none" style={{ flex: 'none' }}>
    <path d={d} stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
const icons = {
  home:    'M2 6.5L8 2l6 4.5V13a1 1 0 01-1 1H3a1 1 0 01-1-1V6.5z',
  deploy:  'M8 1.5v9m0-9L5 4.5m3-3l3 3M2.5 11v2a1 1 0 001 1h9a1 1 0 001-1v-2',
  sql:     'M2.5 4c0-1 2.5-1.8 5.5-1.8S13.5 3 13.5 4v8c0 1-2.5 1.8-5.5 1.8S2.5 13 2.5 12V4zm0 4c0 1 2.5 1.8 5.5 1.8S13.5 9 13.5 8',
  table:   'M2 3.5h12v9H2v-9zm0 3h12M6 6.5v6',
  fn:      'M4 13.5s1-.5 1-2V5c0-1.5 1-2.5 2.5-2.5M3.5 8h4.5m1.5 5.5L14 8m0 5.5L9.5 8',
  logs:    'M3 3.5h10M3 6.5h10M3 9.5h7M3 12.5h4',
  people:  'M10.5 13.5v-1a2.5 2.5 0 00-2.5-2.5h-3a2.5 2.5 0 00-2.5 2.5v1M6.5 7.5a2 2 0 100-4 2 2 0 000 4zM13.5 13.5v-1a2.5 2.5 0 00-1.9-2.4M10.5 3.6a2 2 0 010 3.9',
  chart:   'M2.5 13.5v-4m3.5 4v-8m3.5 8v-5m3.5 5v-10',
  env:     'M4.5 2.5h5l3 3v8a1 1 0 01-1 1h-7a1 1 0 01-1-1v-10a1 1 0 011-1zM9 2.5V6h3.5M6 9h4M6 11.5h4',
  run:     'M8 14.5A6.5 6.5 0 108 1.5a6.5 6.5 0 000 13zM6.5 5.5l4 2.5-4 2.5v-5z',
  repo:    'M6.5 9.5a2.5 2.5 0 013.5 0l2-2a2.5 2.5 0 00-3.5-3.5l-1 1M9.5 6.5a2.5 2.5 0 00-3.5 0l-2 2a2.5 2.5 0 003.5 3.5l1-1',
  bucket:  'M2.5 5.5L8 2.5l5.5 3v5L8 13.5l-5.5-3v-5zM8 8.5l5.5-3M8 8.5l-5.5-3M8 8.5v5',
}

const Item = ({ to, end, icon, children, soon }) =>
  soon ? (
    <span className="side-link soon" title="Todavía no disponible">
      <I d={icons[icon]} />{children}<span className="tag">{soon}</span>
    </span>
  ) : (
    <NavLink to={to} end={end} className={({ isActive }) => `side-link ${isActive ? 'active' : ''}`}>
      <I d={icons[icon]} />{children}
    </NavLink>
  )

export function Sidebar() {
  const { slug } = useParams()
  const base = `/p/${slug}`
  return (
    <nav className="sidebar">
      <Item to={base} end icon="home">Panel de control</Item>
      <Item to={`${base}/deployments`} icon="deploy">Despliegues</Item>
      <Item to={`${base}/logs`} icon="logs">Logs</Item>

      <div className="side-label">Base de datos</div>
      <Item to={`${base}/sql`} icon="sql">Editor SQL</Item>
      <Item to={`${base}/tables`} icon="table">Explorador de tablas</Item>

      <div className="side-label">Funciones</div>
      <Item to={`${base}/functions`} icon="fn">Funciones</Item>
      <Item to={`${base}/runs`} icon="run">Ejecuciones</Item>

      <div className="side-label">Más</div>
      <Item to={`${base}/storage`} icon="bucket">Almacenamiento</Item>
      <Item to={`${base}/metrics`} icon="chart">Métricas</Item>
      <Item to={`${base}/env`} icon="env">Variables de entorno</Item>
      <Item to={`${base}/members`} icon="people">Miembros</Item>
      <Item to={`${base}/settings`} icon="repo">Ajustes</Item>
    </nav>
  )
}
